<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-03-26 
-->
<template>
  <div class="santen-container index">
    <div class="header">
      <div class="middle">
        <img :src="customReportDto.logoPath | logo_show" class="logo-img" @click="goback">
        <ul class="nav">
          <li class="on">
            <a @click="goback">Back to Home</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="search-container">
      <div class="search-ipt">
        <i class="iconfont search-icon">&#xe6d7;</i>
        <Input v-model="chapterParams.keyword" @on-enter="handleRefreshList" placeholder="Search title, content, entity, policy, indication" />
        <Button @click="handleRefreshList">Search</Button>
      </div>
    </div>
    <div class="search-result-container">
      <div class="search-filter">
        <div class="filter-item">
          <DatePicker v-model="dateRange" class="date-range" type="daterange" placeholder="Export by Release Date" format="yyyy-MM-dd" @on-change="handleChangeDate"></DatePicker>
          <Select class="categories-select" v-model="chapterParams.moduleIds" placeholder="By Category" :max-tag-count="1" multiple @on-change="handleRefreshList">
            <Option :value="item.id" v-for="item in categories" :key="item.id">{{item.name}}</Option>
          </Select>
        </div>
        <div class="export-btn" v-if="list.length">
          <Button type="text" @click="handleExport">
            <Icon type="ios-download-outline" />Export all results
          </Button>
        </div>
      </div>

      <div class="result-list">
        <ul class="content-list">
          <li v-for="item,index in list" :key="index">
            <div class="topic" v-if="item.contentType === 0">
              <div class="title">
                <img :src="$store.state.static_img_url + 'pic/briefReport/slash.png'" class="slash">
                <a :href="item.srcUrl" target="_blank" v-html="filter.keyWordHighLight(item.enTitle, currentKeyword)"></a>
              </div>
              <div class="desc" v-html="filter.keyWordHighLight(item.enContent, currentKeyword)"></div>
            </div>
            <div class="report" v-if="item.contentType === 2">
              <a class="image" :href="item.srcUrl" target="_blank">
                <img :src="item.logoPath | logo_show" />
              </a>
              <div class="card">
                <div class="card-top">
                  <a :href="item.srcUrl" target="_blank" class="title" v-html="filter.keyWordHighLight(item.enTitle, currentKeyword)"></a>
                  <div class="desc" v-html="filter.keyWordHighLight(item.enContent, currentKeyword)"></div>
                </div>
                <div class="card-btm">
                  <span v-if="item.srcAuthor"><i class="iconfont">&#xe645;</i>来源：{{item.srcAuthor}}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="no-data" v-if="!list.length && !loading">
          <img :src="$store.state.static_img_url + 'pic/newsletter/nodata-icon.png'" />
          <p>No related results</p>
        </div>
        <div class="no-data2" v-if="list.length && !more && !loading">Reached the end!</div>
        <Spin v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>

      <div ref="indexlist-bottom"></div>
    </div>
    <Spin fix v-if="pageLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop></BackTop>
  </div>
</template>
<script>
import { AchapterInfo, AchapterModuleList, AchapterModuleContentList } from '@/service'
import moment from 'moment'
import filter from 'js/filter'
import axios from 'axios'
import md5 from 'md5'
const crc32 = function (r) {
  for (var a, o = [], c = 0; c < 256; c++) {
    a = c
    for (var f = 0; f < 8; f++) a = 1 & a ? 3988292384 ^ (a >>> 1) : a >>> 1
    o[c] = a
  }
  for (var n = -1, t = 0; t < r.length; t++) n = (n >>> 8) ^ o[255 & (n ^ r.charCodeAt(t))]
  return (-1 ^ n) >>> 0
}
export default {
  components: {},
  created() {
    this.chapterParams.keyword = this.$route.query.keyword
      ? decodeURIComponent(this.$route.query.keyword)
      : ''

    if (this.$route.query.uid && this.$route.query.name) {
      this.getDetail()
    } else {
      this.$Message.error('Invalid URL parameter!')
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const listbox = this.$refs['indexlist-bottom']
        const listrect = listbox.getBoundingClientRect()
        const listabsoluteTop = listrect.top + scrollTop
        if (
          scrollTop + windowHeight > listabsoluteTop &&
          scrollTop > 0 &&
          !this.loading &&
          this.more
        ) {
          this.handleMore()
        }
      }, 10)
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  data() {
    return {
      filter,
      pageLoading: true,
      loading: false,
      more: false,
      dateRange: [],
      chapterIds: [],
      categories: [],
      chapterParams: {
        chapterIds: [],
        keyword: '',
        moduleIds: [],
        startTime: '',
        endTime: '',
        getCount: false,
        page: 1,
        size: 20,
        topCreateTime: null,
      },
      customReportDto: {},
      list: [],
      currentKeyword: '',
      topCreateTime: null
    }
  },
  computed: {},
  methods: {
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    /**
     * 获取月报英文基本信息及期刊
     */
    async getDetail() {
      let res = await AchapterInfo(
        {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
        },
        (error) => this.$Message.error('Request Error!')
      )
      this.pageLoading = false
      if (res.code === 0) {
        if (res.data.customReportDtoList.length) {
          this.$set(this.$data, 'customReportDto', res.data.customReportDtoList[0])
        }
        if (res.data.chapterDtoList.length) {
          this.chapterIds = res.data.chapterDtoList.map((item) => item.id)
          this.chapterParams.chapterIds = this.chapterIds
          this.getModuleList()
          this.handleRefreshList()
        }
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    async getModuleList() {
      const params = {
        startTime: '',
        endTime: '',
        chapterIds: this.chapterIds,
      }
      let res = await AchapterModuleList(params, (error) => this.$Message.error('Request Error!'))
      if (res.code === 0) {
        this.$set(this.$data, 'categories', res.data.moduleList)
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    handleChangeDate() {
      this.chapterParams.startTime = this.dateRange[0]
        ? moment(this.dateRange[0]).format('YYYY-MM-DD 00:00:00')
        : ''
      this.chapterParams.endTime = this.dateRange[1]
        ? moment(this.dateRange[1]).format('YYYY-MM-DD 23:59:59')
        : ''
      this.handleRefreshList()
    },
    async getList() {
      this.loading = true
      this.currentKeyword = this.chapterParams.keyword
      if (!this.currentKeyword) {
        this.list = []
        this.chapterParams.page = 1
        this.loading = false
        return
      }
      this.chapterParams.topCreateTime = this.chapterParams.page == 1 ? null : this.topCreateTime
      let res = await AchapterModuleContentList(this.chapterParams, (error) =>
        this.$Message.error('Request Error!')
      )
      this.loading = false
      if (res.code === 0) {
        this.list = [...this.list, ...res.data.contentDtos]
        this.more = res.data.contentDtos.length == this.chapterParams.size
        if(this.chapterParams.page == 1) this.topCreateTime = res.extraData.topCreateTime
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    handleRefreshList() {
      this.chapterParams.page = 1
      this.list = []
      this.getList()
    },
    handleMore() {
      this.chapterParams.page++
      this.getList()
    },
    handleExport() {
      const { size, page, getCount, topCreateTime, ...params } = this.chapterParams
      
      const timestamp_org = Math.trunc(new Date().getTime() / 1000)
      const timestamp_crc = String(crc32(String(timestamp_org))).substring(0, 3)
      const timestamp = Number(timestamp_org + timestamp_crc)
      const sign = JSON.stringify(params) + timestamp

      axios
        .post(
          this.$store.state.req_url3 + '/api/report/downloadChapterModuleContentList',
          JSON.stringify(params),
          {
            headers: {
              'content-Type': 'application/json; charset=UTF-8',
              timestamp: timestamp,
              sign: md5(sign),
            },
            responseType: 'blob',
          }
        )
        .then((response) => {
          this.exportParams(response)
        })
        .catch((error) => {
          console.error(error)
          this.$Message.error(error)
        })
    },
    exportParams(url) {
      const aLink = document.createElement('a')
      const blob = new Blob([url.data], {
        type: 'application/vnd.ms-excel',
      })
      // 创建一个当前文件的内存URL
      const _href = URL.createObjectURL(blob)
      aLink.style.display = 'none'
      aLink.href = _href
      document.body.appendChild(aLink)
      aLink.setAttribute(
        'download',
        this.customReportDto.enTitle + '_data_' + moment().format('YYYYMMDDHHmmss') + '.xlsx'
      )
      aLink.click()
      document.body.removeChild(aLink)
      // 手动释放创建的URL对象所占内存
      URL.revokeObjectURL(_href)

      this.$nextTick(() => {
        this.$Message.success('Export Success')
      })
    },
    goback() {
      const { keyword, ...params } = this.$route.query
      this.$router.push({
        name: 'EnNewsletter',
        query: params,
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import './style/santen.stylus'
@import './style/searchNewsletter.styl'
</style>